import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {UserService} from '../../services/user/user.service';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {User} from '../../services/user/user';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import {CarrierService} from '../../services/carrier/carrier.service';
import {Carrier} from '../../services/carrier/carrier';
import {CarryForward, WarnBondMessage} from './control-type';
import {ColDef, ColGroupDef, GridOptions, _, GridApi} from 'ag-grid-community';
import {takeWhile} from 'rxjs';
import {BehaviorSubject} from 'rxjs';
import {BidCycleService} from './bidcycle.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import AppConstants, {BondType} from '../../shared/common-components/AppConstants';
import { Subject } from 'rxjs';
import { formatDate } from '@angular/common';
import moment from 'moment';
@Component({
    selector: 'app-hhg-rate-duns',
    templateUrl: './rate-duns.component.html',
    styleUrls: ['./rate-duns.component.css'],
    standalone: false
})
export class RateDunsComponent implements OnInit, OnDestroy {

  disableCheckbox = new Subject();
  currentUser: User | any;
  observer$ = new BehaviorSubject(true);
  disableContinue = true;
  bidcyclesGridOptions: GridOptions = this.initializeGridOptions();
  private gridApi!: GridApi<any>;
  columnDefs: any;
  dunsNumber: any;
  dunsPlus: any;
  uniqueEntityId: any;
  ueiMissing = false;
  errorMessage: string = null;
  rateType: any;
  tmssloader: any;
  carrier: Carrier;
  bidcycles: any = [];
  carryForwardObject: CarryForward;
  warnMessage: WarnBondMessage[] = new Array();
  bidCycle: string;
  showBidCycle: Boolean = false;
  contactEmail: any;
  public overlayNoRowsTemplate;
  contactType: string;
  bsModalRef: BsModalRef;
  selectedBid: any = null;
  @ViewChild('template', {static: true}) template: TemplateRef<any>;
  ffNumber: any;
  ffNumberDom: any;
  mcNumber: any;
  ffNumberIntl: any;
  mcNumberIntl:any;
  usDotNumber: any;
  domesticApprv: boolean;
  intlApprv: boolean;
  usDotNumberIntl: any;
  fmcOtiNUmber: any;
  constructor(private userService: UserService, private hhgrateService: HhgCarrierRateFilingService, private alertService: AlertService,
              private loader: LoadingService, private router: Router, private carrierService: CarrierService, private route: ActivatedRoute,
              private bidCylcleService: BidCycleService, private modalService: BsModalService) {
    this.overlayNoRowsTemplate = '<span>Please wait while data is loading.</span>';
  }

  /**
   * @description getting current user from the behavioural subject and gets the carrier details from the service using userId.
   */

  ngOnInit() {
    this.columnDefs = this.getBidcyclesResultColumnDefs();
    this.tmssloader = this.loader;
    this.route.queryParams
      .pipe(takeWhile(() => this.observer$.value)).subscribe(params => {
      this.rateType = params['rateType'];
    });
    if (this.rateType === 'HHG') {
      this.contactType = 'ERRC';
      this.contactEmail = 'errc@gsa.gov';
    } else {
      this.contactType = 'FMP';
      this.contactEmail = 'transportation.programs@gsa.gov';
    }
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.tmssloader.show();
      this.currentUser = currentUser;
      if (this.currentUser !== null && this.currentUser !== undefined) {
        this.hhgrateService.getCarrierByUser()
          .pipe(takeWhile(() => this.observer$.value)).subscribe((carrier: Carrier) => {
          if (carrier !== null && carrier !== undefined) {
            this.tmssloader.hide();
            this.carrier = carrier;
            this.carrierService.setCarrierObservable(carrier);
            this.dunsNumber = carrier.dunsNumber;
            this.dunsPlus = carrier.dunsPlus;
            this.uniqueEntityId = carrier.uniqueEntityIdentifier;
            const samUeiExpDate = new Date(carrier.samUeiExpDate);
            const today = new Date();
            if (this.rateType === 'HHG' && this.carrier.carrierType  !== 'RFSP' && (carrier.uniqueEntityIdentifier === null || carrier.uniqueEntityIdentifier === "" )) {
              this.disableCheckbox.next(true);
              this.ueiMissing = true;
              this.errorMessage = 'Unique Entity Identifier (UEI) is missing. You cannot continue to file/upload rates unless you update the UEI in TMSS 2.0 by contacting errc@gsa.gov.';
              this.alertService.error('Unique Entity Identifier (UEI) is missing. Please contact errc@gsa.gov to update your UEI in TMSS 2.0.');
            } else if (this.rateType === 'HHG' && this.carrier.carrierType  !== 'RFSP' && (carrier.uniqueEntityIdentifier !== null && carrier.uniqueEntityIdentifier !== "" )) {
              if (samUeiExpDate < today ) {
                this.disableCheckbox.next(true);
                this.ueiMissing = true;
                this.errorMessage = 'Unique Entity Identifier (UEI) is expired. You cannot continue to file/upload rates unless you update the UEI in TMSS 2.0 by contacting errc@gsa.gov.';
                this.alertService.error('Unique Entity Identifier (UEI) is expired. Please contact errc@gsa.gov to update your UEI in TMSS 2.0.');
              }
            } else {
              this.disableCheckbox.next(false);
            }
            if (this.rateType === 'HHG') {
              this.getHhgBidcycles(carrier.carrierId);
              this.overlayNoRowsTemplate = '<span>No Rate Filing windows are currently open.</span>';
            }
            if (this.rateType === 'FRT') {
              this.overlayNoRowsTemplate = `<span>Either no Bidcycles windows are currently open or you haven't participated in any Bidcycle</span>`;
              this.getFrtBidcycles(carrier.carrierId);
              this.columnDefs.push({
                field: 'fuelSurchargeVersion', headerName: 'Fuel Surcharge Version'
              });
              this.columnDefs.push({
                field: 'ltlVersion', headerName: 'LTL Version'
              });
            }
           // aurhoirity info
            const aprovalInformation = this.carrier.carrierApprovalInformationEntity;
            const i = 0;
            for (const appv of aprovalInformation) {
              if ((appv.approvalType === BondType.DOMESTICHHG) && (appv.approvalDate !== null)) {
                this.domesticApprv = true;
                this.ffNumberDom = appv.ffNumber;
                this.mcNumber = appv.mcNumber;
                this.usDotNumber = appv.usDotNumber;
              } else if ((appv.approvalType === BondType.INTERNATIONALHHG) && (appv.approvalDate !== null)) {
                this.intlApprv = true;
                this.ffNumberIntl = appv.ffNumber;
                this.mcNumberIntl = appv.mcNumber;
                this.usDotNumberIntl = appv.usDotNumber;
                this.fmcOtiNUmber = appv.fmcOtiNumber;
              }

            }
          }
        }, error => {
          this.tmssloader.hide();
          this.alertService.error('no carrier associated with the user');
        });
      }
    }, (error) => {
      this.alertService.error('Error while getting user details. Please contact system administrator');
    });
  }

  /**
   * @description comparing bond versus rate effective date
   */
  compareBondEffectiveDate() {
    this.warnMessage = new Array();
    if (AppConstants.isNotNullCondition(this.carrier) && AppConstants.isNotNullCondition(this.bidcycles)) {
      const aprovalInformation = this.carrier.carrierApprovalInformationEntity;
      const i = 0;
      for (const appv of aprovalInformation) {
        if (appv.approvalType === BondType.EXTENDEDSTORAGEHHG || appv.approvalType === BondType.INTERNATIONALHHG) {
          const bondDate = new Date(appv.bondDate);
          const rateEffDate = new Date(this.selectedBid[0].rateEffectiveDate);
          if (bondDate > rateEffDate) {
          } else {
            const aMessage: WarnBondMessage = {
              'approvalType': appv.approvalType,
              'bondDate': appv.bondDate,
              'bidcycleName': this.selectedBid[0].bidcycleName,
              'rateEffectiveDate': this.selectedBid[0].rateEffectiveDate,
            };
            if (appv.bondDate === null) {
              aMessage.warnMessage = 'BondDate is missing';
            } else {
              aMessage.warnMessage = 'New/Updated Bond Required';
            }
            this.warnMessage.push(aMessage);
          }
        }
      }
    }
  }

  /**
   * @description gets the list of control types for HHG Rate Effective Dates.
   * filtering the response to get the latest effective date object
   */
  getFrtBidcycles(carrierId) {
    this.showBidCycle = false;
    this.tmssloader.show();
    this.hhgrateService.getFrtBidCycles(carrierId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.showBidCycle = true;
      this.bidcycles = res as Array<any>;
      this.bidcycles.forEach(bidCycle => {
        bidCycle.closeDate = new Date(bidCycle.closeDate);
      });
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error while getting bidcycles. Please contact system administrator.');
    });
  }


  /**
   * getting FRT control types
   */
  getHhgBidcycles(carrierId) {
    this.tmssloader.show();
    this.hhgrateService.getHhgBidCycles(carrierId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.showBidCycle = true;
      this.bidcycles = res as Array<any>;
      this.bidcycles.forEach(bidCycle => {
        bidCycle.closeDate = new Date(bidCycle.closeDate);
      });
      this.sortSros();
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error while getting bidcycles. Please contact system administrator.');
    });
  }

  processHHGRateFilling() {
    if (this.warnMessage.length > 0) {
      this.bsModalRef.hide();
    }
    this.tmssloader.show();
    this.hhgrateService.getHhgCarryForwardStatus(this.carrier.carrierId, this.selectedBid[0].ratesBidcyclesId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.tmssloader.hide();
      this.carryForwardObject = res;
      if (this.carryForwardObject !== null && this.carryForwardObject !== undefined && Object.keys(this.carryForwardObject).length !== 0) {
        if (this.carryForwardObject.status === 'Accepted' || this.carryForwardObject.status === 'Rejected') {
          this.router.navigate(['/', 'viewhhgrates']);
        } else if (this.carryForwardObject.status === 'Pending') {
          this.alertService.success('The batch process to carry over the rates is still in pending. You will recieve an email' +
            'when it is finished. Please try after sometime.');
          this.router.navigate(['/', 'landing']);
        } else {
          this.router.navigate(['/', 'ratecarryover'], {queryParams: {rateType: 'HHG'}});
        }
      } else {
        this.router.navigate(['/', 'ratecarryover'], {queryParams: {rateType: 'HHG'}});
      }
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error while getting carry forward status. Please contact system administrator');
    });
  }

  /**
   * @description calls carry forward service to get carryforward status. if the status is either rejected/accepted route is /viewhhgrates
   * if not route is /ratecarryover; if it is pending route them too landing page.
   */
  goToCarryOverComponent() {
    const selectedBidCycle = this.gridApi.getSelectedRows()[0];
    this.selectedBid = this.gridApi.getSelectedRows();
    this.bidCylcleService.setExpiryTime(selectedBidCycle.closeDate);
    this.carrierService.setRateBidCycleId(this.gridApi.getSelectedRows()[0]);
    if (this.rateType === 'HHG') {
      if (selectedBidCycle.hhgSupplemental) {
        this.router.navigate(['/', 'viewhhgrates']);
      } else {
        this.compareBondEffectiveDate();
        if (this.warnMessage.length > 0) {
          this.bsModalRef = this.modalService.show(this.template);
        } else {
          this.processHHGRateFilling();
        }

      }
    } else if (this.rateType === 'FRT') {
      this.tmssloader.show();
      this.hhgrateService.getfrtCarryForwardStatus(this.carrier.carrierId, selectedBidCycle.ratesBidcyclesId)
        .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
        this.tmssloader.hide();
        this.carryForwardObject = res;
        if (this.carryForwardObject !== null && this.carryForwardObject !== undefined && Object.keys(this.carryForwardObject).length !== 0) {
          if (this.carryForwardObject.status === 'Accepted' || this.carryForwardObject.status === 'Rejected') {
            const carryOverBidCycle = this.gridApi.getSelectedRows();
            const navigationExtras: NavigationExtras = {
              state: { bicCycleObj: carryOverBidCycle }
            };
            this.router.navigate(['/', 'viewfrtrates'], navigationExtras);
          } else if (this.carryForwardObject.status === 'Pending') {
            this.alertService.success('The batch process to carry over the rates is still in pending. You will recieve an email' +
              'when it is finished. Please try after sometime.');
            this.router.navigate(['/', 'landing']);
          } else {
            this.router.navigate(['/', 'ratecarryover'], {queryParams: {rateType: 'FRT'}});
          }
        } else if (res === null) {
          this.router.navigate(['/', 'ratecarryover'], {queryParams: {rateType: 'FRT'}});
        }
      }, error => {
        this.tmssloader.hide();
        this.alertService.error('Error while getting carry forward status. Please contact system administrator');
      });
    } else {
      this.router.navigate(['/', 'error']);
    }
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'single',
      defaultColDef: {
        sortable: true,
        resizable: true,
        autoHeight: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowData: this.bidcycles,
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
        // this.gridApi.setDatasource(this.hhgRateQueryResults);
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  getBidcyclesResultColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'Select',
          headerCheckboxSelectionFilteredOnly: true,
          width: 120,
         checkboxSelection: this.disableContinue
         /*
         checkboxSelection: params => {
          this.disableCheckbox.subscribe(val => {
          return val;
          })
        } */
        },
      {
        headerName: 'Rate Filing Name',
        field: 'bidcycleName',
        width: 250
      },
      {
        headerName: 'Rate Filing Open Date',
        field: 'openDate',
        cellRenderer: (data) => {
          return data.value ? moment(data.value).format("YYYY-MM-DD") : '';
        }
      },
      {
        headerName: 'Rate Filing Close Date',
        field: 'closeDate',
        cellRenderer: (data) => {
          return data.value ? (moment(data.value).format("YYYY-MM-DD H:mm:ss")) + ' ET': '';
        }
      },
      {
        headerName: 'Rate Effective Date',
        field: 'rateEffectiveDate',
        cellRenderer: (data) => {
          return data.value ? moment(data.value).format("YYYY-MM-DD") : '';
        }
      },
      {
        headerName: 'Rate Filing IDs',
        field: 'sros',
        width: 260,
        autoHeight: true,
        cellClass: 'cell-wrap-text'
      },
      {
        headerName: 'PC Miler Version',
        field: 'pcmiller'
      }
    ];
  }

  onSelectionChanged(event: any) {
    const selectedRows = this.gridApi.getSelectedRows();
    const samUeiExpDate = new Date(this.carrier.samUeiExpDate);
    const today = new Date();
    this.disableContinue = selectedRows.length === 0;
    if (this.rateType === 'HHG' && this.carrier.carrierType  !== 'RFSP' && (this.carrier.uniqueEntityIdentifier === null || this.carrier.uniqueEntityIdentifier === "" )){
      this.disableCheckbox.next(true);
      this.disableContinue = true;
    } else if (this.rateType === 'HHG' && this.carrier.carrierType  !== 'RFSP' && (this.carrier.uniqueEntityIdentifier !== null && this.carrier.uniqueEntityIdentifier !== "" )) {
      if (samUeiExpDate < today ) {
        this.disableCheckbox.next(true);
        this.disableContinue = true;
      }
    } else {
      this.disableCheckbox.next(false);
    }

  }

  sortSros() {
    let sroArray;
    this.bidcycles.forEach(e => {
      sroArray = e.sros.split(',');
      sroArray.sort();
      e.sros = sroArray.toString();
    });
  }

  /**
   * destroying the subscription
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
